export const EMPLOYEE_SEARCH_LOAN_KEY = 'employee-search-loan';
export const LOAN_CALC_PREVIEW_KEY = 'LOAN_CALC_PREVIEW';
export const BASIC_USER_LOAN_DATA_KEY = 'BASIC_USER_LOAN_DATA';
export const LOAN_CATEGORIES_ADMIN_KEY = 'LOAN_CATEGORIES_ADMIN';
export const LOAN_CATEGORY_DETAIL_KEY = 'LOAN_CATEGORY_DETAIL';

export { INTEREST_TYPES } from 'components/LoanPaymentV2/constants';
